import React, { useState, useMemo } from "react";
import {
    FaComment,
    FaEllipsisH,
    FaEllipsisV,
    FaFile,
    FaFlag,
    FaMarker,
    FaPen,
    FaSave,
    FaShare,
    FaThumbsUp,
    FaTimes,
    FaTrash
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import Linkify from "linkify-react";

import UserImage from "../images/userProfile.png";
import "./components.css";
import { api } from "../app/Api/ApiSlice";
import { toast } from "react-toastify";

const UserPostCard = ({ userPost }) => {


    const navigate = useNavigate();
    const userId = useSelector((state) => state.auth.user?._id);

    const [profileInfo, setProfileInfo] = useState(false);
    const [postInfo, setPostInfo] = useState(false);
    const [loadDelete, setloadDelete] = useState(false)
    const [isLiked, setIsLiked] = useState(userPost?.isLiked)
    const [likesCount, setLikesCount] = useState(userPost?.likesCount)

    const imageFiles = useMemo(
        () => userPost?.files?.filter(f => f.type === "image") || [],
        [userPost]
    );

    const [focusedImg, setFocusedImg] = useState(imageFiles[0]?.url || null);

    const linkifyOptions = {
        target: "_blank",
        rel: "noopener noreferrer",
        className: "post-link"
    };

    const toggleProfileInfo = () => {
        setPostInfo(false);
        setProfileInfo(prev => !prev);
    };
    const toggleLiked = async () => {
        // 1. Determine the action based on current state
        const originalIsLiked = isLiked;
        const originalLikesCount = likesCount;

        // 2. Optimistically update UI
        setIsLiked(!originalIsLiked);
        setLikesCount(prev => originalIsLiked ? prev - 1 : prev + 1);

        try {
            // 3. Make the API call
            const response = await api.patch(`/posts/${userPost._id}/likes`);

            if (response.status !== 200) {
                throw new Error("Failed to update like");
            }
            else {
                toast.success("like updated")
            }

        } catch (error) {
            // 4. Rollback on error
            setIsLiked(originalIsLiked);
            setLikesCount(originalLikesCount);

            console.error("Like error:", error);
            toast.error("Could not update like. Please try again.");
        }
    };

    const togglePostInfo = () => {
        setProfileInfo(false);
        setPostInfo(prev => !prev);
    };

    const shareContent = async () => {
        if (!navigator.share) {
            alert("Sharing not supported on this browser");
            return;
        }

        await navigator.share({
            title: "Onnize",
            text: "Check this out on Onnize",
            url: `${window.location.origin}/post/${userPost._id}`
        });
    };

    const renderImages = () => (
        <>
            {focusedImg && (
                <div className="focused-image">
                    <img src={focusedImg} alt="post" />
                </div>
            )}

            {imageFiles.length > 1 && (
                <div className="image-selector">
                    {imageFiles.map((file) => (
                        <div
                            key={file.url}
                            className="image-selector-wrapper"
                            onClick={() => setFocusedImg(file.url)}
                        >
                            <img src={file.url} alt={file.name} />
                        </div>
                    ))}
                </div>
            )}
        </>
    );

    const renderVideo = (file) => (
        <div className="video-container">
            <video controls preload="metadata">
                <source src={file.url} type={file.mimeType || "video/mp4"} />
            </video>
        </div>
    );

    const renderDocuments = () => (
        <div className="document-container">
            {userPost.files.map((file) => {
                const ext = file?.name?.split(".").pop().toLowerCase();

                return ext === "pdf" ? (
                    <div key={file.url} className="document-preview">
                        <iframe src={file.url} title={file.name} loading="lazy" />
                        <a href={file.url} target="_blank" rel="noopener noreferrer">
                            Open PDF
                        </a>
                    </div>
                ) : (
                    <div key={file.url} className="document-download">
                        <span>{file.name}</span>
                        <a href={file.url} target="_blank" rel="noopener noreferrer">
                            <FaFile />
                        </a>
                    </div>
                );
            })}
        </div>
    );

    const renderFiles = () => {
        if (!userPost?.files?.length) return null;

        const firstFile = userPost.files[0];

        if (firstFile.type === "image") return renderImages();
        if (firstFile.type === "video") return renderVideo(firstFile);
        if (firstFile.type === "document") return renderDocuments();

        return null;
    };

    const deletePost = async () => {
        const confirmed = window.confirm("Delete this post?");
        if (!confirmed) return;

        try {
            setloadDelete(true);

            const res = await api.delete(`/posts/${userPost._id}`);

            if (res.data.success) {
            } else {
                alert("Failed to delete post");
            }
        } catch (err) {
            console.error(err);
            alert("Something went wrong deleting post");
        } finally {
            setloadDelete(false);
        }
    };

    const handleBookmark = async (id, type) => {
        setPostInfo(false)
        try {
            const response = await api.post('/feeds/bookmarks', {
                post: id,
                type: type
            });


            if (response.data.success) {
                alert("Bookmarked!");
            } else {
                alert(response.data.message);
            }

        } catch (error) {
            alert("Something went wrong. Please try again.");
        } finally {
            // Optional: End loading state
        }
    };

    const handelFollow = async (id) => {
        setProfileInfo(false)
        try {
            const response = await api.post('/community/follow', {
                followed: id
            });


            if (response.data.success) {
                alert("Bookmarked!");
            } else {
                alert(response.data.message);
            }

        } catch (error) {
            alert("Something went wrong. Please try again.");
        } finally {
            // Optional: End loading state
        }
    }
    const handleReport = async (id, type) => {
        setPostInfo(false)
        try {
            const response = await api.post('/feeds/report', {
                post: id,
                type
            });


            if (response.data.success) {
                alert("post reported!");
            } else {
                alert(response.data.message);
            }

        } catch (error) {
            alert("Something went wrong. Please try again.");
        } finally {
            // Optional: End loading state
        }
    }


    return (
        <div className="post">
            {/* HEADER */}
            <div className="post-header">
                <div className="profile-details">
                    <img
                        src={userPost?.createdBy?.profilePic || UserImage}
                        alt="profile"
                        className="userpost-profile-img"
                    />
                    <div>
                        <p className="post-profile-name" onClick={() => navigate(`/user/${userPost.createdBy._id}`)}>
                            {userPost?.createdBy?.firstname} {userPost?.createdBy?.lastname}
                        </p>
                        <div className="post-dates">
                            <p>{moment(userPost.createdAt).fromNow()}</p>
                            <p className="post-audience">{userPost.audience}</p>
                        </div>
                    </div>
                </div>

                <FaEllipsisV onClick={toggleProfileInfo} />
            </div>

            {/* PROFILE INFO */}
            <div className={profileInfo ? "user-profile-info" : "user-closed-info"}>
                <FaTimes onClick={toggleProfileInfo} />
                <button onClick={() => handelFollow(userPost.createdBy._id)}><FaMarker /> Follow</button>
            </div>

            {/* POST INFO */}
            {/* {console.log(postInfo)} */}
            <div className={postInfo ? "user-post-info" : "user-closed-info"}>
                <FaTimes onClick={togglePostInfo} />
                <button onClick={() => handleBookmark(userPost._id, "user")}><FaSave /> Bookmark</button>
                <button onClick={shareContent}><FaShare /> Share</button>
                <button onClick={() => handleReport(userPost._id, "user")}><FaFlag /> Report</button>
                {userPost?.createdBy?._id === userId && (
                    <button
                        onClick={() =>
                            navigate(`/profile/${userPost.createdBy._id}/${userPost._id}/edit`)
                        }
                    >
                        <FaPen /> Edit
                    </button>
                )}
                {
                    userPost?.createdBy?._id === userId && (
                        <button onClick={deletePost}><FaTrash /> Edit</button>)
                }
            </div>

            {/* BODY */}
            {userPost.postText && (
                <div
                    className="feed-post-text"
                    onClick={() => navigate(`/post/${userPost._id}`, { state: { post: userPost } })}
                >
                    <Linkify options={linkifyOptions}>
                        <p
                            onClick={(e) => {
                                if (e.target.tagName === "A") e.stopPropagation();
                            }}
                        >
                            {userPost?.postText?.length > 200
                                ? userPost.postText.substring(0, 200) + '...'
                                : userPost.postText}
                        </p>
                    </Linkify>
                </div>
            )}

            {/* FILES */}
            <div className="postcard-images">{renderFiles()}</div>

            {/* FOOTER */}
            <div className="post-footer">
                <div className="post-footer-icon">
                    <FaThumbsUp onClick={toggleLiked} />
                    <p>{likesCount || 0}</p>
                </div>

                <div
                    className="post-footer-icon"
                    onClick={() => navigate(`/post/${userPost._id}`, { state: { post: userPost } })}
                >
                    <FaComment />
                    <p>{userPost.commentsCount || 0}</p>
                </div>

                <div className="post-footer-icon" onClick={togglePostInfo}>
                    <FaEllipsisH />
                </div>
            </div>
        </div>
    );
};

export default UserPostCard;
